
    import { mapActions, mapState } from 'vuex';
    import { useI18next } from '@composables/i18next';
    import ChipScene from '../chips/animation/ChipScene';
    const { chips } = {"_public":true,"chips":[{"x":-1.1922917506265918,"y":1.5,"z":-2.5191626409085486,"plane":"back"},{"x":-0.8984425082320995,"y":1.5,"z":-2.576527992962969,"plane":"back"},{"x":-0.6042644125079099,"y":1.5,"z":-2.773834301355058,"plane":"back"},{"x":-0.2845916128953132,"y":1.5,"z":-2.6177443568061127,"plane":"back"},{"x":0.01752904729327076,"y":1.5,"z":-2.4200798452348224,"plane":"back"},{"x":0.3134880618792095,"y":1.5,"z":-2.482958545577813,"plane":"back"},{"x":0.6127117531144208,"y":1.5,"z":-2.9351720545823197,"plane":"back"},{"x":0.9001947431083941,"y":1.25,"z":-2.2685556145961434,"plane":"back"},{"x":-1.1922917506265918,"y":2.5,"z":-2.5191626409085486,"plane":"back"},{"x":-0.8984425082320995,"y":2.5,"z":-2.576527992962969,"plane":"back"},{"x":-0.6042644125079099,"y":2.5,"z":-2.773834301355058,"plane":"back"},{"x":-0.2845916128953132,"y":2.5,"z":-2.6177443568061127,"plane":"back"},{"x":0.01752904729327076,"y":2.5,"z":-2.4200798452348224,"plane":"back"},{"x":0.3134880618792095,"y":2.5,"z":-2.482958545577813,"plane":"back"},{"x":0.6127117531144208,"y":2.5,"z":-2.9351720545823197,"plane":"back"},{"x":0.9001947431083941,"y":2.25,"z":-2.2685556145961434,"plane":"back"},{"x":-1.1922917506265918,"y":3.5,"z":-2.5191626409085486,"plane":"back"},{"x":-0.8984425082320995,"y":3.5,"z":-2.576527992962969,"plane":"back"},{"x":-0.6042644125079099,"y":3.5,"z":-2.773834301355058,"plane":"back"},{"x":-0.2845916128953132,"y":3.5,"z":-2.6177443568061127,"plane":"back"},{"x":0.01752904729327076,"y":3.5,"z":-2.4200798452348224,"plane":"back"},{"x":0.3134880618792095,"y":3.5,"z":-2.482958545577813,"plane":"back"},{"x":0.6127117531144208,"y":3.5,"z":-2.9351720545823197,"plane":"back"},{"x":0.9001947431083941,"y":3.25,"z":-2.2685556145961434,"plane":"back"},{"x":-0.4431809061971001,"y":1.25,"z":-0.8866059666484953,"plane":"front"},{"x":0.14588454630109915,"y":1.25,"z":-0.7571329729251346,"plane":"front"},{"x":0.4560261335901359,"y":1.25,"z":-0.9069204527281938,"plane":"front"},{"x":-0.4545293187970931,"y":1.25,"z":-0.5154804407797944,"plane":"front"},{"x":-0.1608521743234439,"y":1.25,"z":-0.8844523288871051,"plane":"front"},{"x":-0.4431809061971001,"y":2.25,"z":-0.8866059666484953,"plane":"front"},{"x":0.14588454630109915,"y":2.25,"z":-0.7571329729251346,"plane":"front"},{"x":0.4560261335901359,"y":2.25,"z":-0.9069204527281938,"plane":"front"},{"x":-0.4545293187970931,"y":2.25,"z":-0.5154804407797944,"plane":"front"},{"x":-0.1608521743234439,"y":2.25,"z":-0.8844523288871051,"plane":"front"},{"x":-0.4431809061971001,"y":3.25,"z":-0.8866059666484953,"plane":"front"},{"x":0.14588454630109915,"y":3.25,"z":-0.7571329729251346,"plane":"front"},{"x":0.4560261335901359,"y":3.25,"z":-0.9069204527281938,"plane":"front"},{"x":-0.4545293187970931,"y":3.25,"z":-0.5154804407797944,"plane":"front"},{"x":-0.1608521743234439,"y":3.25,"z":-0.8844523288871051,"plane":"front"}]};
    export default {
        setup () {
            const { t, vT } = useI18next(['game']);
            return { t, vT };
        },
        data () {
            return {
                sizes: {
                    mobile: {
                        width: 640,
                        height: 1000,
                    },
                    desktop: {
                        width: 1200,
                        height: 1000,
                    },
                },
                currentSize: {
                    width: 640,
                    height: 1000,
                },
                chipScenes: [
                    { ref: 'back', minZ: -3, count: 8, rangeX: 3, config: chips.filter(item => item.plane === 'back') },
                    { ref: 'front', minZ: -1.5, count: 5, rangeX: 1.5, config: chips.filter(item => item.plane === 'front') },
                ],
                animationDuration: 7000,
                latestDelta: 0,
                criticalDelta: false,
                maxDelta: 65,
                deltaCount: 0,
                maxDeltaCount: 25,
            };
        },
        computed: {
            ...mapState(['ui']),
            aspectRatios () {
                const ratios = {};
                Object.keys(this.sizes).forEach(item => {
                    ratios[item] = this.sizes[item].width / this.sizes[item].height;
                });
                return ratios;
            },
            animating () {
                return this.ui.animatingChips;
            },
            didWin () {
                return this.$store?.state?.award?.prizeWon;
            },
            resultCopy () {
                return this.didWin ? this.t('game:chipfetti.win') : this.t('game:chipfetti.lose');
            },
        },
        watch: {
            animating (newValue) {
                if (newValue) {
                    this.chipScenes.forEach(item => {
                        if (item.scene) item.scene.animate();
                    });
                    this.delayedSwitch();
                }
            },
        },
        mounted () {
            this.manageAspectRatio();
            this.chipScenes = this.chipScenes.map(item => ({ ...item, scene: new ChipScene(this.$refs[item.ref], item.config, this.deltaHandler) }));

            this.chipScenes.forEach(item => {
                if (item.scene) item.scene.resize(this.currentSize);
            });

            const resizeObserver = new ResizeObserver((entries) => {
                this.manageAspectRatio();
            });
            resizeObserver.observe(this.$refs.back);
        },
        methods: {
            ...mapActions({
                setChipAnimation: 'ui/setChipAnimation',
            }),
            manageAspectRatio () {
                if (this.$refs.back) {
                    const { width, height } = this.$refs.back.getBoundingClientRect();
                    const elementRatio = width / height;
                    if (Math.abs(elementRatio - this.aspectRatios.mobile) < Math.abs(elementRatio - this.aspectRatios.desktop)) {
                        this.updateSize(this.sizes.mobile);
                    }
                    else {
                        this.updateSize(this.sizes.desktop);
                    }
                }
            },
            updateSize ({ width, height }) {
                if (this.currentSize.width !== width || this.currentSize.height !== height) {
                    this.currentSize.width = width;
                    this.currentSize.height = height;
                    this.chipScenes.forEach(item => {
                        if (item.scene) item.scene.resize(this.currentSize);
                    });
                }
            },
            async delayedSwitch () {
                await new Promise(resolve => setTimeout(resolve, this.animationDuration / 2));
                if (this.didWin) {
                    this.$router.replace('/inky');
                }
                else {
                    this.$router.replace('/janky');
                }
                await new Promise(resolve => setTimeout(resolve, this.animationDuration / 2));
                this.setChipAnimation(false);
                this.chipScenes.forEach(item => {
                    if (item.scene) item.scene.reset();
                });
            },
            deltaHandler (delta) {
                if (!this.criticalDelta) {
                    if (delta > this.maxDelta) {
                        this.deltaCount++;
                    }
                }
                this.criticalDelta = this.deltaCount > this.maxDeltaCount;

                if (this.criticalDelta) {
                    this.markRemovals();
                }

            },

            markRemovals () {

                this.chipScenes.forEach(item => {
                    item.scene.removeExtraChips();
                });
            },

        },
    };
